import common from './components/common'
import accordionFaq from './components/accordion-faq'

common.autocompleteSearchV2()
common.viewData()
common.setAlertStyle()
common.onScroll()
common.controlMobileSearch()
common.closeBanner()
common.controlMobileMenu()
common.insertImgAlt()
common.insertIframeTitle()
common.initMetrics()
common.activeTab()
common.activeMobileTab()
accordionFaq.handleAnswerOpening()
